import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import FooterDescription from "./FooterDescription";
import { dynamicFailed } from "../hooks/custom/useToast";
import { fetchFooterDetails } from "../api/FooterApi";
import { IFooterDetailsData } from "../exports/interfaces";
import { useCompanyDetailsContext } from "../context/CompanyDetailsContext";

export const Footer = () => {
  const { companyDetailsData } = useCompanyDetailsContext();
  const [footerDetails, setFooterDetails] = useState<IFooterDetailsData[]>([]);
  useEffect(() => {
    Promise.all([fetchFooterDetails()])
      .then(([footerDetailsData]) => {
        setFooterDetails(footerDetailsData);
      })
      .catch((error) => {
        dynamicFailed(error.response.data.error.message);
      });
  }, []);

  return (
    <footer className="td_footer td_style_1">
      <div className="container">
        <div className="td_footer_row">
          <div className="td_footer_col d-flex align-items-center">
            <div className="td_footer_widget">
              <div className="td_footer_text_widget td_fs_18">
                <img
                  src={`${process.env.REACT_APP_cmsUrl}${footerDetails[0]?.logo[0]?.media?.url}`}
                  alt="Logo"
                  // className="logo-img"
                  width="325px"
                  height="auto"
                />

                {/* <img
                  src={`${process.env.REACT_APP_cmsUrl}${footerDetails[0]?.logo[0]?.media?.url}`}
                  alt="Logo"
                  width="325px"
                  height="auto"
                />
                <div className="logo-text">
                  Academic Excellence with Purpose
                </div> */}
                {/* <p>{footerDetails[0]?.description}</p> */}
              </div>
            </div>
          </div>
          <div className="td_footer_col">
            <div className="td_footer_widget">
              <h2 className="td_footer_widget_title td_fs_32 td_white_color td_medium td_mb_30">
                Navigate
              </h2>
              <div className="d-flex gap-5">
                <ul className="td_footer_widget_menu">
                  <li>
                    <Link to="/about">About</Link>
                  </li>
                  <li>
                    <Link to="/sast">Academics</Link>
                  </li>
                  <li>
                    <Link to="/application-form">Admissions & Aids</Link>
                  </li>
                  <li>
                    <Link to="/community-faculty">Community</Link>
                  </li>
                </ul>
                <ul className="td_footer_widget_menu">
                  <li>
                    <Link to="/vacancy">Vacancy</Link>
                  </li>
                  <li>
                    <Link to="/news">News</Link>
                  </li>
                  <li>
                    <Link to="/events">Events</Link>
                  </li>
                  <li>
                    <Link to="/faqs">FAQs</Link>
                  </li>
                </ul>
              </div>
              {/* <li>
                  <Link to="/contact">Contact</Link>
                </li> */}
              {/* <h2 className="td_footer_widget_title td_fs_32 td_white_color td_medium td_mb_30">
                Current Affairs
              </h2>
              <ul className="td_footer_widget_menu">
                <li>
                  <Link to="/">Vacancy</Link>
                </li>
                <li>
                  <Link to="/">News</Link>
                </li>
                <li>
                  <Link to="/">Events</Link>
                </li>
              </ul> */}
            </div>
          </div>
          <div className="td_footer_col">
            <div className="td_footer_widget">
              <h2 className="td_footer_widget_title td_fs_32 td_white_color td_medium td_mb_30">
                <Link to="/contact">Contact</Link>
              </h2>
              <div className="td_newsletter td_style_1">
                <ul className="td_footer_address_widget td_medium td_mp_0">
                  <li>
                    <i className="fa-solid fa-phone"></i>
                    <a href={`tel:${companyDetailsData[0]?.telephone_number}`}>
                      {companyDetailsData[0]?.telephone_number}
                    </a>
                  </li>
                  <li>
                    <i className="fa-solid fa-mobile"></i>
                    <a href={`tel:${companyDetailsData[0]?.mobile_number}`}>
                      {companyDetailsData[0]?.mobile_number}
                    </a>
                  </li>
                  <li>
                    <i className="fa-solid fa-envelope"></i>
                    <a href={`mailto:${companyDetailsData[0]?.email}`}>
                      {companyDetailsData[0]?.email}
                    </a>
                  </li>
                  <li>
                    <i className="fa-solid fa-location-dot"></i>
                    <a
                      href={companyDetailsData[0]?.get_direction}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {companyDetailsData[0]?.company_address}
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="td_footer_bottom td_fs_18">
        <div className="container">
          <div className="td_footer_bottom_in">
            <p className="td_copyright mb-0 text-center">
              Copyright © {new Date().getFullYear()} University of Nepal | All
              Rights Reserved &nbsp;
              <FooterDescription />
            </p>
            <ul className="td_footer_widget_menu">
              <li>
                <Link to="/">Terms & Conditions</Link>
              </li>
              <li>
                <Link to="/">Privacy & Policy</Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </footer>
  );
};
